import { useEffect } from "react";
import { setFavIcon } from "../../../../utils/embed-utils";
import { DtoPublicTest } from "@/types/dto-types";

export function useTestIconAndTitle(publicTest: DtoPublicTest) {
  useEffect(() => {
    const { name, client } = publicTest;

    if (name) {
      document.title = name;
    }

    if (client?.favIconUrl) {
      setFavIcon(client.favIconUrl);
    }
  }, [publicTest]);
}
